// Molecules
import VmClientDisclosure from './molecules/vm-client-disclosure/vm-client-disclosure';

import VmChatbotSkeleton from './vm-chatbot-skeleton/vm-chatbot-skeleton';

import VmListPagination from './vm-list-pagination/vm-list-pagination';
export { VmProfileImage } from './atoms/vm-profile-image/vm-profile-image';
import VmSortDropdown from './vm-sort-dropdown/vm-sort-dropdown';

// Molecules
customElements.define('vm-client-disclosure', VmClientDisclosure);

// Organisms
customElements.define('vm-chatbot-skeleton', VmChatbotSkeleton);

customElements.define('vm-list-pagination', VmListPagination);
customElements.define('vm-sort-dropdown', VmSortDropdown);
